/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { getUpdateRolesPermissions, getUpdateRolesPermissionsMassive } from 'src/utils/permissions';
import { BaseAction } from '../../types/global.type';
import * as actions from '../../types/user.type';

export type UserState = {
  licenses: Array<any>,
  isSetting: boolean,
  error?: any,
  permissions?: any,
};

const initialState: UserState = {
  licenses: [],
  isSetting: false,
  error: null,
  permissions: [],
}

export const userReducer = (
  state: UserState = initialState,
  action: BaseAction
) => {
  switch (action.type) {
    case actions.GET_USER_LICENSES:
      return {...state, isSetting: true, error: null}
    case actions.GET_USER_LICENSES_SUCCESS:
      return {
        ...state,
        licenses: action.payload,
        error: null,
        isSetting: false
      }
    case actions.GET_USER_LICENSES_FAILURE:
      return {...state, error: action.payload, isSetting: false}
    case actions.GET_USER_HAS_PERMISSION_SUCCESS:
      return {
        ...state,
        permissions: getUpdateRolesPermissionsMassive(state.permissions, action.payload),
        isSettingPermissions: false,
      }
    default:
      return state;
  }
};
